// extracted by mini-css-extract-plugin
module.exports = {"content":"DownApp__content___3bpS1","qrcode":"DownApp__qrcode___18ufC","scanMsg":"DownApp__scanMsg___3LkQ3","mark":"DownApp__mark___2gnb4"};